import React, { useState } from "react";
import { AppBar, Toolbar, Box, Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import LogoImg from "../assets/images/computer.png";
import LogoutModal from "./LogOutModal";

export default function NavBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [logoutOpen, setLogoutOpen] = useState(false);

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          background: "linear-gradient(135deg, var(--primary-navy) 0%, #151e2e 100%)",
          boxShadow: "0 4px 20px rgba(15, 23, 42, 0.12)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
          zIndex: 1100,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", px: { xs: 2, sm: 4 } }}>
          {/* Logo and App Title */}
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2, cursor: "pointer" }}
            onClick={() => navigate("/cs-home")}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                p: "4px 8px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <img src={LogoImg} alt="Logo" style={{ height: "30px", width: "auto" }} />
            </Box>
            
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 } }}>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => navigate("/cs-home")}
              sx={{
                color: "#fff",
                fontWeight: 600,
                fontSize: "14px",
                fontFamily: "'Cairo', 'Inter', sans-serif",
                textTransform: "none",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                },
              }}
            >
              {t("addCall") || "Search"}
            </Button>
            
            <IconButton
              color="inherit"
              onClick={() => setLogoutOpen(true)}
              sx={{
                ml: 1,
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "8px",
                p: 1,
                "&:hover": {
                  backgroundColor: "rgba(239, 75, 31, 0.15)",
                  color: "#ef4b1f",
                },
              }}
            >
              <LogoutIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <LogoutModal open={logoutOpen} handleClose={() => setLogoutOpen(false)} />
    </>
  );
}
